import { useMutation } from '@tanstack/react-query';
import {
  generalEnquiryApi,
  type GeneralEnquiryCreateInput,
  type GeneralEnquiryExportParams,
  type VerifyRecaptchaInput,
  type VerifyRecaptchaResponse,
} from './general-enquiry.api';

export const useCreateGeneralEnquiry = () => {
  return useMutation({
    mutationFn: (input: GeneralEnquiryCreateInput) => generalEnquiryApi.create(input),
  });
};

export const useExportGeneralEnquiries = () => {
  return useMutation({
    mutationFn: (params: GeneralEnquiryExportParams) => generalEnquiryApi.export(params),
  });
};

export const useVerifyRecaptcha = () => {
  return useMutation({
    mutationFn: (input: VerifyRecaptchaInput): Promise<VerifyRecaptchaResponse> =>
      generalEnquiryApi.verifyRecaptcha(input),
  });
};
